import { createSelector } from "reselect";
import { calculateHeightsAndTimes } from "shared/itemLists/CursorItemsCoordinator/functions/cursorFunctions";
import { DateHelper } from "shared/helpers/DateHelper";
import { getActItems } from "shared/itemLists/redux/selectors/getActItems";

const getPlanItems = (state) => state.items;
const getDueItems = (state) => state.dueItems;
const getToday = (state) => state.today;
const getDoneItems = (state) => state.doneItems;

export const getPlanHeightsAndTimes = createSelector(
  [getPlanItems, getDueItems, getToday],
  (planItems, dueItems, today) => {
    const dateHelper = new DateHelper(today);
    return calculateHeightsAndTimes(planItems, { dueItems, dateHelper });
  }
);

export const getActHeightsAndTimes = createSelector(
  [getActItems, getDueItems, getToday],
  (actItems, dueItems, today) => {
    const dateHelper = new DateHelper(today);
    return calculateHeightsAndTimes(actItems, { dueItems, dateHelper });
  }
);

export const getDoneHeightsAndTimes = createSelector(
  [getDoneItems, getToday],
  (doneItems) => {
    return calculateHeightsAndTimes(doneItems, []);
  }
);
